import {isUndefined} from 'lodash';
import styled from 'styled-components';
import {useDispatch} from 'react-redux';

import {SkeletonLoader} from '~/shared/components/Loaders';
import {getLocalizationService} from '~/shared/services/localisationService';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';
import {PriceLabel} from '~/shared/components/PriceLabels';
import {setUserReportOrderDetails} from '~/shared/store/actions';
import {pushRoute} from '~/shared/router';
import {ActiveOrderState} from '~/shared/store/models';
import {EMPTY_OBJECT} from '~/shared/consts/commonConsts';
import {Arrow, TableMobileWrapper, Column} from '~/shared/components/UserTransactions/components/styled';
import {Title} from '~/shared/components/UserTransactions/shared';

import MobileLoaderComponent from './MobileLoaderComponent';

type MobileProps = {
  rows: {
    id: number;
    orderPrice: number;
    resName: string;
    dateAndTime: string;
    deliveryMethod: string;
    orderStatus: string;
    etaDelivery: string;
  }[];
};

const ColumnWithBorder = styled(Column)`
  border-bottom: 2px solid ${({theme}) => theme.colors.darkBackground};

  &:last-child {
    border-bottom: 0;
  }
`;

const InnerRow = styled.div<{bold?: boolean}>`
  display: flex;
  font-weight: ${({bold}) => (bold ? 'bold' : 'normal')};
`;
const RowTitle = styled.div`
  font-weight: bold;
  min-width: 130px;
  ${flipOnLTR`
    margin-left: 8px;
  `}
`;

const RowDetails = styled.div<{bold?: boolean}>`
  font-weight: ${({bold}) => (bold ? 'bold' : 'normal')};
`;

const CustomArrow = styled(Arrow).attrs(({theme: {isLTR}}) => ({
  forward: isLTR,
}))`
  display: block;
  height: 15px;
  width: 10px;
  ${flipOnLTR`
    left: 15px;
    right: auto;
  `}
`;

const MobileActiveOrders = ({rows}: MobileProps) => {
  const {t} = getLocalizationService();
  const dispatch = useDispatch();

  const onRowClick = async (rowData: Partial<ActiveOrderState>) => {
    await dispatch(setUserReportOrderDetails(rowData));
    pushRoute('/personal-area?section=my-orders&showOrder=true&activeOrder=true');
  };

  return (
    <>
      {/* @ts-expect-error Title needs to be rewritten as ts */}
      <Title isMobile>{t('active_orders')}</Title>

      <TableMobileWrapper>
        <SkeletonLoader shouldShowLoader={isUndefined(rows)} LoaderComponent={MobileLoaderComponent}>
          {rows.map((row, index) => {
            const {orderPrice, resName, id, dateAndTime, orderStatus, etaDelivery} = row || EMPTY_OBJECT;

            return (
              // @ts-expect-error ColumnWithBorder needs to be rewritten as ts
              <ColumnWithBorder key={id || index} narrow onClick={() => onRowClick(row)}>
                <InnerRow>
                  <RowTitle>{t('date_and_time')}</RowTitle>
                  <RowDetails>{dateAndTime}</RowDetails>
                </InnerRow>
                <InnerRow>
                  <RowTitle>{t('business_name_2')}</RowTitle>
                  <RowDetails bold>{resName}</RowDetails>
                </InnerRow>
                <InnerRow>
                  <RowTitle>{t('order_type')}</RowTitle>
                  <RowDetails>{orderStatus}</RowDetails>
                </InnerRow>
                <InnerRow>
                  <RowTitle>{t('eta_delivery')}</RowTitle>
                  <RowDetails>{etaDelivery}</RowDetails>
                </InnerRow>
                <InnerRow bold>
                  <RowTitle>{t('sum')}</RowTitle>
                  <PriceLabel price={orderPrice} bold />
                </InnerRow>
                <CustomArrow noAlt />
              </ColumnWithBorder>
            );
          })}
        </SkeletonLoader>
      </TableMobileWrapper>
    </>
  );
};

export default MobileActiveOrders;
